import { useState } from 'react';
import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import { UMSidebar } from '../_components';
import type { SidebarMenu } from '../_components';
import { useLibraryLayers } from './hooks';
import { LibraryPanel } from './LibraryPanel';
import { TopBar } from './TopBar';

export const meta = {
  title: 'Menu des couches — Favoris',
  description: 'Piste A : le panel "Couches" est composé par l\'utilisateur (bibliothèque personnelle) via un picker + une bibliothèque de couches, sans catégorisation.',
  tags: ['map', 'territory', 'po'],
  author: 'clemence.fandard',
  status: 'draft' as const,
};

export default function MenuCouchesFavoris() {
  const [activeMenu, setActiveMenu] = useState<SidebarMenu | null>('layers');
  const state = useLibraryLayers();

  const handleToggleMenu = (menu: SidebarMenu) => {
    setActiveMenu((prev) => (prev === menu ? null : menu));
  };

  return (
    <PrototypeStudioLayout title="UrbanMap — Menu des couches (Favoris)">
      <div style={{ display: 'flex', width: '100%', height: 'calc(100vh - 56px)', overflow: 'hidden' }}>

        <UMSidebar activeMenu={activeMenu} onToggleMenu={handleToggleMenu} />

        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
          <TopBar />

          <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
            {activeMenu === 'layers' && (
              <LibraryPanel
                steps={state.steps}
                library={state.library}
                libraryLayers={state.libraryLayers}
                visible={state.visible}
                pickerOpen={state.pickerOpen}
                pickerSearch={state.pickerSearch}
                pickerStep={state.pickerStep}
                pickerResults={state.pickerResults}
                activeCount={state.activeCount}
                librarySize={state.librarySize}
                catalogSize={state.catalogSize}
                onSetPickerOpen={state.setPickerOpen}
                onSetPickerSearch={state.setPickerSearch}
                onSetPickerStep={state.setPickerStep}
                onToggleVisible={state.toggleVisible}
                onToggleLibrary={state.toggleLibrary}
                onRemoveFromLibrary={state.removeFromLibrary}
                onClearAll={state.clearAll}
                onClose={() => setActiveMenu(null)}
              />
            )}

            <main style={{
              flex: 1, background: '#e8ecf0',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexDirection: 'column', gap: 8,
              color: '#94a3b8', fontSize: 14,
            }}>
              <span style={{ fontSize: 40 }}>🗺</span>
              <span>Carte Mapbox (placeholder)</span>
              <span style={{ fontSize: 12 }}>
                {state.activeCount === 0
                  ? 'Aucune couche activée pour le moment'
                  : `${state.activeCount} couche${state.activeCount > 1 ? 's' : ''} activée${state.activeCount > 1 ? 's' : ''} s'afficherai${state.activeCount > 1 ? 'ent' : 't'} ici`}
              </span>
            </main>
          </div>
        </div>

      </div>
    </PrototypeStudioLayout>
  );
}
